import request from '@/config/axios'
export const getCategoryList = () => request.get({ url: '/rental/category/list' })
export const createCategory = (data: any) => request.post({ url: '/rental/category/create', data })
export const updateCategory = (data: any) => request.put({ url: '/rental/category/update', data })
export const deleteCategory = (id: number) => request.delete({ url: '/rental/category/delete', params: { id } })
